export const toolboxConstants = {
    "PROJECT": {
        "logo": require("assets/img/create_cards/project-plan.png"),
        "name": "Project",
        "description":
            "Create a project to manage all your work in one place.",
        "identifier": "project",
        "inProgress": false,
        "icons": true,
        "route": "/create/project",
    },
    "CONCEPT_LABS": {
        "logo": require("assets/img/create_cards/labs.png"),
        "name": "Concept Labs",
        "description":
            "Create interactive concept labs to provide hands-on experience to students.",
        "identifier": "labs",
        "inProgress": false,
        "route": "/create/labdesign",
        "icons": true,
    },
    "FORM": {
        "name": "Form Generator",
        "logo": require("assets/img/create_cards/form_design.png"),
        "description": "Create a form to convert plans into action.",
        "identifier": "form",
        "inProgress": false,
        "icons": true,
        "route": "/create/form-design",
    },
    "MODEL_DEVELOPMENT": {
        "name": "Model Development Plan Generator",
        "logo": require("assets/img/create_cards/model_development.png"),
        "description": "Create interactive models to analyze data and make predictions.",
        "identifier": "model_development",
        "inProgress": false,
        "icons": true,
        "route": "/create/model_development",
    },
    "MODEL_VALIDATION": {
        "name": "Model Validation Plan Generator",
        "logo": require("assets/img/create_cards/model_validation.png"),
        "description": "Create interactive models to validate data and make predictions.",
        "identifier": "model_validation",
        "inProgress": false,
        "icons": true,
        "route": "/create/model_validation",
    },
    "COURSE": {
        "name": "Course",
        "logo": require("assets/img/create_cards/course.png"),
        "description": "Create interactive courses to share knowledge and insights.",
        "identifier": "course",
        "inProgress": false,
        "icons": true,
        "route": "/create/course-design",
    },
    "RESEARCH_REPORT": {
        "name": "Research Report",
        "logo": require("assets/img/create_cards/report.png"),
        "description": "Create in-depth research reports to present data-driven insights.",
        "identifier": "research_report",
        "inProgress": false,
        "icons": true,
        "route": "/create/research_report",
    },
    "WHITE_PAPER": {
        "name": "White Paper",
        "logo": require("assets/img/create_cards/whitepaper.png"),
        "description": "Create detailed white papers to showcase expertise on critical topics.",
        "identifier": "white_paper",
        "inProgress": false,
        "icons": true,
        "route": "/create/white_paper",
    },
    "BLOG": {
        "logo": require("assets/img/create_cards/blog.png"),
        "name": "Blog",
        "description":
            "Create impactful blogs to share thoughts and expertise with the world.",
        "identifier": "blog",
        "inProgress": false,
        "route": "/create/blog",
    },
    "NEWS_LETTER": {
        "logo": require("assets/img/create_cards/newsletter.png"),
        "name": "Newsletter",
        "description":
            "Create engaging newsletters to share updates and insights with your audience.",
        "identifier": "news_letter",
        "inProgress": false,
        "route": "/create/news_letter",
    },
    "CASE_STUDY": {
        "logo": require("assets/img/create_cards/case-study.png"),
        "name": "Case Study",
        "description":
            "Create detailed case studies to showcase expertise and success stories.",
        "identifier": "case_study",
        "inProgress": false,
        "route": "/create/case_study",
    },
    "HANDOUT": {
        "logo": require("assets/img/create_cards/handout.png"),
        "name": "Handout",
        "description":
            "Create informative handouts to share knowledge and insights.",
        "identifier": "handout",
        "inProgress": false,
        "route": "/create/handout",
    },
    "KEY_INSIGHTS": {
        "logo": require("assets/img/create_cards/insights.png"),
        "name": "Key Insights",
        "description":
            "Create key insights to share valuable information and knowledge.",
        "identifier": "key_insights",
        "inProgress": false,
        "incons": true,
        "route": "/create/key_insights",
    },
    "PODCAST": {
        "logo": require("assets/img/create_cards/podcast.png"),
        "name": "Podcast",
        "description": "Create engaging podcasts to share insights and knowledge.",
        "identifier": "podcast",
        "inProgress": false,
        "route": "/create/podcast",
    },
    "PROJECT_PLAN": {
        "logo": require("assets/img/create_cards/project-plan.png"),
        "name": "Project Plan",
        "description": "Create a project plan to manage all your work in one place.",
        "identifier": "project_plan",
        "inProgress": false,
        "route": "/create/project_plan",
    },
    "SESSION": {
        "logo": require("assets/img/create_cards/session.png"),
        "name": "Session",
        "description": "Create interactive sessions to manage and organize artifacts through a structured pipeline process.",
        "identifier": "session",
        "inProgress": false,
        "icons": true,
        "route": "/create/sessions",
    },
};